module.exports = __webpack_public_path__ + "static/media/gallery-23.1fcc5063.jpg";